/**
 * Header
 * @class
 * @constructor
 * @public
 */
class Header {
  /**
   * Constructor
   * @param {string} name The container to handle
   * @returns {object} options The options
   * @returns {class}
   */
  constructor() {
    // Params
    this.headerMenu = document.getElementById('header-menu--js');
    this.headerMenuOpenButton = document.getElementById('header-open-menu--js');
    this.headerMenuBg = document.getElementById('header__menu-bg--js');

    // Variables
    this.isOpen = false;

    // Engage engines
    if (this.headerMenu && this.headerMenuOpenButton) {
      this.init();
    }
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init() {
    const that = this;

    this.headerMenuOpenButton.addEventListener('click', function(event) {
      event.preventDefault();
      that._toggleMenu();
    });

    that.headerMenuBg.addEventListener('click', function(event) {
      event.preventDefault();
      that._closeMenu();
    });

    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        that._closeMenu();
      }
    };

    return this;
  }

  /**
   * On menu toggle
   * @returns {void}
   */
	_toggleMenu() {
    this.isOpen ? this._closeMenu() : this._openMenu();
  }

  /**
   * On menu open
   * @returns {void}
   */
	_openMenu() {
    this.headerMenu.setAttribute('aria-hidden', false);
    this.headerMenuOpenButton.classList.add('is-active');
    this.isOpen = true;
  }

  /**
   * On menu close
   * @returns {void}
   */
  _closeMenu() {
    this.headerMenu.setAttribute('aria-hidden', true);
    this.headerMenuOpenButton.classList.remove('is-active');
    this.isOpen = false;
  }

  /**
   * Class name
   * @returns {string} The human readable class name
   */
	get name() {
    return 'Header';
	}
};

module.exports = Header;
